import { Workflow, formatDateToMMDDYYYY } from '@gripp/shared-logic';
import { ReminderAlertType } from '../components/issue/types';

type ReminderDefaultValues = {
  alertType?: ReminderAlertType;
  inputField?: string | number;
  days?: number;
  dayInterval?: number;
  dayIntervalUnit?: string;
  daysStartDate?: string;
  onDate?: string;
  notes?: string;
};

export const getReminderDefaultValues = (workflow?: Workflow): ReminderDefaultValues => {
  if (!workflow) return {};

  const { name, trigger } = workflow;
  const excludedConfigKeys = ['dayIntervalUnit', 'issueId', 'startDate'];
  const configKeys = Object.keys(trigger.config)
    .filter((key) => !excludedConfigKeys.includes(key));

  let alertType;
  let inputField;
  let days;
  let dayInterval;
  let dayIntervalUnit;
  let daysStartDate;
  let onDate;
  let notes;

  switch (configKeys[0]) {
    case 'onDate':
      if (configKeys.includes('dayInterval')) {
        dayIntervalUnit = trigger.config.dayIntervalUnit;
        dayInterval = trigger.config.dayInterval;
        alertType = ReminderAlertType.DayInterval;
      } else {
        alertType = ReminderAlertType.Date;
      }

      onDate = formatDateToMMDDYYYY(trigger.config.onDate);
      inputField = formatDateToMMDDYYYY(trigger.config.onDate);
      notes = name;
      break;

    case 'every':
      days = trigger.config.every;
      alertType = ReminderAlertType.Days;
      inputField = trigger.config.every;
      daysStartDate = formatDateToMMDDYYYY(trigger.config.startDate);
      notes = name;
      break;

    default:
      break;
  }

  return {
    alertType,
    days,
    daysStartDate,
    inputField,
    notes,
    onDate,
    dayInterval,
    dayIntervalUnit,
  };
};
